const Theme = () => {
    return (

        <>
            <div className="theme-child">
                <div className="bLack-box">
                <p>Featured travelogue</p>
                <h1>An Olympic experience in Washington</h1>
                <a>Read more</a>
                </div>
             </div>
        
        </>
    )
}
export default Theme;